import React, { useContext, useEffect, useState } from "react";
import { useMutation, useLazyQuery } from "@apollo/client";

import { useRedirectLogged } from "../../Hooks/useRedirectLogged";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/GlobalContext";
import { RoutesNames } from "../../components/utils/routes";
import { GET_THEMES_INTEREST } from "../../Graphql/queries/queryGetThemesInterest";
import { MUTATION_CREATE_THEME_INTEREST } from "../../Graphql/mutations/mutationCreateThemeInterest";
import { useToastSuccessful } from "../../Hooks/useToastSuccessful";
import { MUTATION_UPDATE_THEME_INTEREST } from "../../Graphql/mutations/mutationUpdateThemeInterest";
import { MUTATION_DELETE_THEME_INTEREST } from "../../Graphql/mutations/mutationDeleteThemeInterest";
import { useToastError } from "../../Hooks/useToastError";
import { useToastLoading } from "../../Hooks/useToastLoading";
import HeaderMain from "../../components/header/headerMain";
import CardRedirectionLink from "../../components/cards/CardRedirectionLink";
import IconPreview from "../../components/Icons/IconPreview";
import IconNext from "../../components/Icons/IconNext";
import { AppForm } from "../../forms/AppForm";
import { validationFormThemesInterest } from "../../components/validations/validationThemesInterest";
import { AppInput } from "../../forms/AppInput";
import { AppTextArea } from "../../forms/AppTextArea";
import { AppImage } from "../../forms/AppImage";
import { AppSubmit } from "../../forms/AppSubmit";
import { Variables } from "../../styles/Variables";
import PrimaryNormal from "../../components/buttons/PrimaryNormal";
import ModalQuestion from "../../Modals/ModalQuestion";

import {
  ContainerForm,
  TextInterest,
  Content,
  AnimationLoading,
  ContainerLinks,
  Left,
  Right,
  ContainerPagination,
  ContainerButton,
  ContainerGlobal,
} from "../../styles/PageStyles/InterestThemes/stylesThemesInterest";

const ThemesInterest = () => {
  useRedirectLogged();
  const navigate = useNavigate();
  const { user, rol } = useContext(GlobalContext);

  useEffect(() => {
    if (rol !== "ADMIN") {
      navigate(RoutesNames.login);
    }
  }, [rol, navigate]);

  const [delTheme, setDelTheme] = useState(null);
  const [editTheme, setEditTheme] = useState(null);
  const [quitImage, setQuitImage] = useState(false);
  const [showDel, setShowDel] = useState(false);
  const [page, setPage] = useState(1);
  const toastSuccessful = useToastSuccessful();

  const [getThemes, { error, data, loading, refetch }] = useLazyQuery(GET_THEMES_INTEREST);

  const [createTheme, { error: errorCreate, loading: loadingCreate }] = useMutation(MUTATION_CREATE_THEME_INTEREST, {
    onCompleted: (e) => {
      setQuitImage(false);
      refetch();
      toastSuccessful(e.createThemeOfInterest.message);
    },
    onError: (err) => console.error(err),
  });

  const [UpdateTheme, { error: errorUpdate, loading: loadingUpdate }] = useMutation(MUTATION_UPDATE_THEME_INTEREST, {
    onCompleted: (e) => {
      setEditTheme(null);
      setQuitImage(false);
      refetch();
      toastSuccessful(e.updateThemeOfInterest.message);
    },
    onError: (err) => console.error(err),
  });

  const [deleteTheme, { error: errorDel, loading: loadingDel }] = useMutation(MUTATION_DELETE_THEME_INTEREST, {
    onCompleted: (e) => {
      setDelTheme(null);
      setShowDel(false);
      refetch();
      toastSuccessful(e.deleteThemeOfInterest.message);
    },
    onError: (err) => console.error(err),
  });

  useToastError(error || errorCreate || errorDel || errorUpdate);
  useToastLoading(loadingCreate, "Creando...");
  useToastLoading(loadingDel, "Eliminando...");
  useToastLoading(loadingUpdate, "Actualizando...");

  useEffect(() => {
    getThemes({
      variables: {
        page: page,
        pageSize: 3,
      },
    });
  }, [page, getThemes]);

  useEffect(() => {
    if (delTheme) {
      setShowDel(true);
    }
  }, [delTheme]);

  const handleSubmit = (values, { resetForm }) => {
    let img = null;
    if (!quitImage) {
      img = undefined;
    }
    if (values.image) {
      img = values.image;
    }
    console.log({
      title: values.title,
      description: values.description,
      url: values.url,
      background: undefined,
      image: img,
    });
    createTheme({
      variables: {
        title: values.title,
        description: values.description,
        url: values.url,
        background: undefined,
        image: img,
      },
    });
    resetForm();
  };

  const handleUpdate = (values, { resetForm }) => {
    let img = null;
    if (!quitImage) {
      img = undefined;
    }
    if (values.image) {
      img = values.image;
    }
    UpdateTheme({
      variables: {
        themeOfInterestId: editTheme.id,
        title: values.title,
        description: values.description,
        url: values.url,
        background: null,
        image: img,
      },
    });
    resetForm();
  };

  const handleDelete = () => {
    if (delTheme) {
      deleteTheme({
        variables: {
          themeOfInterestId: delTheme,
        },
      });
    }
  };

  const handlePreviewPage = () => {
    setPage(page - 1);
  };

  const handleNextPage = () => {
    setPage(page + 1);
  };

  return (
    <ContainerGlobal>
      <HeaderMain user={user} rol={rol} />
      <ContainerForm>
        <Left>
          <TextInterest>Temas de interés...</TextInterest>
          {loading ? (
            <Content>
              <AnimationLoading />
            </Content>
          ) : (
            <>
              <ContainerLinks>
                {data?.getThemesOfInterest.data.map((item) => (
                  <CardRedirectionLink
                    item={item}
                    setDelTheme={setDelTheme}
                    setEditTheme={setEditTheme}
                    admin
                    key={item.id}
                  />
                ))}
              </ContainerLinks>
              <ContainerPagination>
                <ContainerButton style={page === 1 ? { visibility: "hidden" } : null} onClick={handlePreviewPage}>
                  <IconPreview />
                  Anterior
                </ContainerButton>
                <div>
                  {page} de{" "}
                  {data?.getThemesOfInterest.meta.pageCount === 0
                    ? data?.getThemesOfInterest.meta.pageCount + 1
                    : data?.getThemesOfInterest.meta.pageCount}
                </div>
                <ContainerButton
                  style={
                    data?.getThemesOfInterest.meta.pageCount === 0 || page === data?.getThemesOfInterest.meta.pageCount
                      ? { visibility: "hidden" }
                      : null
                  }
                  onClick={handleNextPage}
                >
                  Siguiente
                  <IconNext />
                </ContainerButton>
              </ContainerPagination>
            </>
          )}
        </Left>
        <Right>
          <TextInterest>{editTheme ? "Editar tema de interés." : "Crear nuevo tema de interés."}</TextInterest>
          <AppForm
            initialValues={{
              title: "",
              description: "",
              url: "",
              image: null,
              background: null,
            }}
            onSubmit={editTheme ? handleUpdate : handleSubmit}
            validationSchema={validationFormThemesInterest}
          >
            <AppInput
              label="Titulo: "
              name="title"
              placeholder="Titulo del tema de interés"
              preloadedInfoFromBackend={editTheme !== null ? editTheme.title : null}
              style={{ height: "40px", marginTop: 10 }}
            />
            <AppTextArea
              label="Descripción: "
              name="description"
              placeholder="Escribe una descripción."
              preloadedInfoFromBackend={editTheme?.description || null}
            />
            <AppInput
              label="URL: "
              name="url"
              placeholder="Escribe la dirección url donde se redireccionara."
              preloadedInfoFromBackend={editTheme?.url || null}
              style={{ height: "40px", marginTop: 10 }}
            />
            <AppImage
              label="Imagen: "
              name="image"
              quitImage={quitImage}
              setQuitImage={setQuitImage}
              preloadedInfoFromBackend={editTheme?.image || null}
              imageStyle={{ width: "100px", height: "100px" }}
            />
            <AppSubmit title={editTheme ? "Actualizar" : "Crear"} style={{ backgroundColor: Variables.colorOrange }} />
            {editTheme && (
              <PrimaryNormal
                title="Cancelar"
                onClick={() => {
                  setEditTheme(null);
                  window.reload();
                }}
              />
            )}
          </AppForm>
        </Right>
      </ContainerForm>
      <ModalQuestion
        setModalVisible={setShowDel}
        modalVisible={showDel}
        question="Seguro que desea eliminarlo"
        pressYes={handleDelete}
        pressNo={() => {
          setShowDel(false);
          setDelTheme(null);
        }}
      />
    </ContainerGlobal>
  );
};

export default ThemesInterest;
